import React, { useState } from "react";
import rightIcon from "../right-arrow.svg"
import crossIcon from "../cross.svg"
import addIcon from "../add.svg"
import { useSelector } from "react-redux";
import questionList from "./questionsList.json"

const camelize = (input) => {
  return input.split('_')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
}

const RequestSupportLogin = () => {
  const [questionKey, setQuestionKey] = useState("general");
  const [openIndex, setOpenIndex] = useState([]);
  const { getUserDetail } = useSelector((state) => state.auths);

  const generalTitle = `Steps to Add an ${camelize(questionKey)}?`
  const generalContent = `1. Open the ${camelize(questionKey)}s list page.\n2. Click on add ${camelize(questionKey)} button on the top right of the page.\n3. Add details as requested.`
  const generalEditTitle = `How to invite a ${camelize(questionKey === "trust" ? "grantor_user" : questionKey)} to the trust?`
  const generalEditContent = function (key = camelize(questionKey === "trust" ? "grantor_user" : questionKey)) {
    return `1. Open the trusts list page.\n2. Click on trust you want to invite ${key}.\n3. Go to section ${key.split(' ')[0]}(s).\n4. Click on Add ${key.split(' ')[0]}.\n5. Add details as requested.\n6. After save you can see invite button click on it and confirm invite.`
  }

  let generalQuestions = [
    {name: "General Question", key: "general"},
    {name: "Grantor User Questions", key: "grantor_user"},
    {name: "Attorney User Questions", key: "attorney_user"},
    {name: "Successor User Questions", key: "successor_user"},
    {name: "Trust Questions", key: "trust"}
  ]

  const answers = {
    general: [
      {
        title: "How to Edit our Personal account details?",
        content: "1. Open your own profile by clicking on the to right corner.\n2. Click on edit button.\n3. Update which ever detail you want to update by clicking on it."
      },
      {
        title: "How to reset password?",
        content: "1. Open your own profile by clicking on the to right corner.\n2. Click on edit button.\n3. Click on reset password button.\n4. Update your password by providing new password."
      }
    ],
    successor_user: [
      {
        title: generalTitle,
        content: generalContent
      },
      {
        title: generalEditTitle,
        content: generalEditContent()
      }
    ],
    trust: [
      {
        title: "How to create a Trust?",
        content: "1. Open the Trust list page.\n2. Click on add Trust button on the top right of the page.\n3. Fill out all the required details."
      },
      {
        title: generalEditTitle,
        content: generalEditContent()
      }
    ],
    admin_user: [
      {
        title: generalTitle,
        content: generalContent
      },
      {
        title: "How to Edit Admin User details?",
        content: "1. Open the admin users list page.\n2. Click on user you want to edit.\n3. Click on edit button.\n4. Update which ever detail you want to update by clicking on it."
      }
    ],
    ...questionList
  }

  const handleAccordon = (index) => {
    setOpenIndex(prevArray => {
      if (!prevArray.includes(index)) {
        return [...prevArray, index];
      } else {
        const oldIndex = prevArray.indexOf(index);
        if (oldIndex > -1) {
          const newArray = [...prevArray];
          newArray.splice(oldIndex, 1);
          return newArray;
        }
        return prevArray;
      }
    });
  }

  if(getUserDetail && (getUserDetail.role === 1 || getUserDetail.role === 5)) {
    generalQuestions.push({name: "Admin User Questions", key: "admin_user"})
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="py-4">
            <div className="support-head">Help & FAQs </div>
            <div className="support-head fw-semibold text-muted mt-0">
              <small>Here are the list of Frequently asked Questions.</small>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <ul className="faq-sidebar p-0 mb-4 ms-0">
            {generalQuestions.map((el) => (
              <li key={el.key}>
                <button
                  onClick={() => {
                    setQuestionKey(el.key);
                    setOpenIndex([]);
                  }}
                  className="d-flex justify-content-between align-items-center text-black p-3 w-100 text-start border-0 cursor-pointer"
                  type="button"
                >
                  <span>{el.name}</span>
                  <img alt="show" src={rightIcon} className={`me-2 ${el.key === questionKey && 'rotate-arrow'}`} />
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-md-8">
          <div className="answers">
            {answers[questionKey].map((el, index) => {

              return (
                <div key={el.title} className="answer p-3 fs-5">
                  <div className="d-flex justify-content-between">
                    <span>{el.title}</span>
                    <button
                      type="button"
                      className="bg-transparent border-0 p-0 m-0 cursor-pointer"
                      onClick={() => handleAccordon(index)}
                      aria-label={openIndex.includes(index) ? "Collapse" : "Expand"}
                    >
                      <img
                        alt="open or close"
                        src={openIndex.includes(index) ? crossIcon : addIcon}
                      />
                    </button>
                  </div>
                  <div className={`${openIndex.includes(index) ? 'd-block' : 'd-none'} mt-3`}>
                    <p
                      style={{ whiteSpace: "pre-line", lineHeight: "1.7rem" }}
                      dangerouslySetInnerHTML={{ __html: el.content }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestSupportLogin;
